import { render, staticRenderFns } from "./NewCarousel.vue.html?vue&type=template&id=d518deee&scoped=true&"
import script from "./NewCarousel.component.js?vue&type=script&lang=vueJs&"
export * from "./NewCarousel.component.js?vue&type=script&lang=vueJs&"
import style0 from "./NewCarousel.scoped.scss?vue&type=style&index=0&id=d518deee&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518deee",
  null
  
)

export default component.exports